export default __webpack_public_path__ + "static/media/brands-storyvault.5df108c7.png";